import type { Preset } from "@primeuix/themes/types";
import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";

/**
 * @description PrimeVue has deprecated the pre-built pass through themes. Use this when it is not viable to create the entire component styles from scratch and need a starting point. We are currently using the PrimeVue Aura preset as a base.
 *
 * To use the preset in a component, simply omit the 'unstyled' and 'pt-options' prop on the PrimeVue component and use normal scss to apply overrides to the desired classes
 */
export const taiPreset: Preset = definePreset(Aura, {
  name: "tai-custom-preset"
});
